import { render } from "./Edit.vue?vue&type=template&id=7ca72356"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Wholesale/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ca72356"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ca72356', __exports__)) {
    api.reload('7ca72356', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=7ca72356", () => {
    api.rerender('7ca72356', render)
  })

}


export default __exports__